import AttributesModel from '../AttributesModel';
import Model from '../Model';
import UserFriendlyQueryModel from './UserFriendlyQueryModel';

export default class AqlQueryModel extends Model {

	constructor(data) {
		super(data);
		this.query_name = data.query_name;
		this.aql = data.aql || '';

		if(data.release_bundle_query_fields) {
			this.release_bundle_query_fields = new UserFriendlyQueryModel(data.release_bundle_query_fields || {});
		}

		if (data.added_props && data.added_props.length) {
			this.added_props = data.added_props.map(prop => {
				return new AttributesModel({
					name: prop.name || prop.key,
					values: prop.values,
					valuesDelimiter: ', '
				});
			});
		} else {
			this.added_props = [];
		}

		if (data.mappings && data.mappings.length) {
			this.mappings = data.mappings.map(pathParam => {
				return new AttributesModel({
					name: pathParam.name || pathParam.input,
					values: pathParam.values || pathParam.output
				});
			});
		} else {
			this.mappings = [];
		}
	}

	build() {
		let aqlJson = {
			aql: this.aql,
			query_name: this.query_name
		};

		if(this.release_bundle_query_fields) {
			aqlJson.release_bundle_query_fields = this.release_bundle_query_fields.build();
			aqlJson.aql = this.release_bundle_query_fields.buildAql();
		}


		if (this.added_props && this.added_props.length) {
			aqlJson.added_props = this.added_props.map(prop => {
				return prop.build('key', 'values', false);
			});
		}

		if (this.mappings && this.mappings.length) {
			aqlJson.mappings = this.mappings.map(pathParam => {
				return pathParam.build('input', 'output', true);
			});
		}

		return aqlJson;
	}

	toUserFirendlyQuerySrting() {
		return this.release_bundle_query_fields ?
			this.release_bundle_query_fields.toUserFirendlyQuerySrting() : `AQL: ${this.aql}`;
	}
}



// WEBPACK FOOTER //
// ./modules/distribution/core/models/distribution/AqlQueryModel.js